module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_0_0@2x.471431ec.png";